import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isLoggedIn } from '../../utils/auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4613/auth';

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token && isLoggedIn()) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['History'],
  endpoints: (builder) => ({
    getHistory: builder.query({
      query: (params = {}) => ({
        url: '/history',
        method: 'GET',
        params: {
          page: params.page,
          limit: params.limit,
          status: params.status,
        }
      }),
      providesTags: ['History'],
    }),
  }),
});

export const {
  useGetHistoryQuery,
} = historyApi; 